const settings = {
    selectors: {
        container: '.full-width-content .table-container',
    },
};

export default class PrivacyPolicyTable {
    constructor(
        container,
    ) {
        // Determine the number columns and get references to their header HTML
        const headerRows = container.querySelectorAll('thead > tr');

        if (headerRows.length <= 0) {
            throw new Error();
        }

        let headerColumns;
        if (headerRows.length > 1) {
            headerColumns = headerRows[headerRows.length - 1].querySelectorAll(':scope > td');
        } else {
            headerColumns = headerRows[0].querySelectorAll(':scope > td');
        }

        if (headerColumns.length <= 0) {
            throw new Error();
        }

        const headerHtml = [];
        for (const headerColumn of headerColumns) {
            headerHtml.push(headerColumn.innerHTML);
        }

        // Create our mobile representation of the table
        const mobileContainer = document.createElement('div');
        mobileContainer.className = 'table-container--mobile';
        container.after(mobileContainer);

        // If the table had more than one header, insert them first
        for (let i=0; i<headerRows.length - 1; i++) {
            const mobileHeader = document.createElement('div');
            mobileHeader.className = 'table-container--mobile__header';
            mobileHeader.innerHTML = headerRows[i].querySelector(':scope > td').innerHTML;
            mobileContainer.appendChild(mobileHeader);
        }

        // Loop through all of the <tbody> rows and add their content
        const bodyRows = container.querySelectorAll('tbody > tr');
        for (const bodyRow of bodyRows) {
            const bodyColumns = bodyRow.querySelectorAll(':scope > td');
            if (bodyColumns.length != headerHtml.length) {
                throw new Error();
            }

            for (let i=0; i<headerHtml.length; i++) {
                const mobileItem = document.createElement('dl');
                mobileContainer.appendChild(mobileItem);

                const mobileHeader = document.createElement('dt');
                mobileHeader.className = 'table-container--mobile__header';
                mobileHeader.innerHTML = headerHtml[i];
                mobileItem.appendChild(mobileHeader);

                const mobileCell = document.createElement('dd');
                mobileCell.innerHTML = bodyColumns[i].innerHTML;
                mobileItem.appendChild(mobileCell);
            }
        }
    }

    static init() {
        const elements = document
            .querySelectorAll(settings.selectors.container);

        for (const element of elements) {
            new PrivacyPolicyTable(element);
        }
    }
}
